import { render, staticRenderFns } from "./BasketBall.vue?vue&type=template&id=5fd70596&scoped=true"
import script from "./BasketBall.vue?vue&type=script&lang=js"
export * from "./BasketBall.vue?vue&type=script&lang=js"
import style0 from "./BasketBall.vue?vue&type=style&index=0&id=5fd70596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd70596",
  null
  
)

export default component.exports